import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.management.import');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type TenantOption = {
    id: string;
    name: string;
    status: string;
    commit_allowed: boolean;
};

@Component({
    selector: 'wiz-page-ip-management-import',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.management.import/view.scss */
:host {
  display: block;
  height: 100%;
  transform: none !important;
}

.import-page {
  color: #0f172a;
}

.import-step {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  color: #94a3b8;
  transition: color 180ms ease, background-color 180ms ease;
}

.step-number {
  display: inline-flex;
  width: 1.75rem;
  height: 1.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #f8fafc;
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
}

.import-step--active {
  background: #ecfdf5;
  color: #047857;
}
.import-step--active .step-number {
  border-color: #6ee7b7;
  background: #047857;
  color: #fff;
}

.import-step--done {
  color: #047857;
}
.import-step--done .step-number {
  border-color: #a7f3d0;
  background: #d1fae5;
  color: #047857;
}

.mapping-card--wide {
  grid-column: 1/-1;
  align-items: flex-start;
}

.mapping-card__status {
  flex: 0 0 auto;
  white-space: nowrap;
}

.commit-progress__indeterminate {
  width: 38%;
  animation: commit-progress-slide 1.15s ease-in-out infinite;
  will-change: transform;
}

@keyframes commit-progress-slide {
  0% {
    transform: translateX(-115%);
  }
  100% {
    transform: translateX(285%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .commit-progress__indeterminate {
    width: 100%;
    animation: none;
    opacity: 0.55;
  }
}
.status-pulse {
  animation: status-pulse 1.4s ease-in-out infinite;
}

@keyframes status-pulse {
  0%, 100% {
    opacity: 0.35;
    transform: scale(0.85);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .status-pulse {
    animation: none;
    opacity: 1;
  }
}
.excel-preview-grid th,
.excel-preview-grid td {
  background-clip: padding-box;
  vertical-align: top;
}
.excel-preview-grid tbody tr:nth-child(even) td {
  background-color: #f8fafc;
}
.excel-preview-grid tbody tr:hover td {
  background-color: #ecfdf5;
}

.excel-preview-grid__row {
  position: sticky;
  left: 0;
  z-index: 10;
  width: 4rem;
  min-width: 4rem;
  background-color: #f8fafc;
}

thead .excel-preview-grid__row {
  z-index: 30;
  background-color: #f1f5f9;
}

.excel-preview-grid__error td,
.excel-preview-grid__error:nth-child(even) td {
  background-color: #fff7f7;
}

.excel-preview-grid__error:hover td {
  background-color: #fff1f2;
}

.excel-preview-modal-backdrop {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw;
  height: 100dvh;
}

.excel-preview-modal {
  max-height: calc(100dvh - 1rem);
}

.excel-preview-modal--all {
  height: 94dvh;
}

.excel-preview-modal--errors .excel-preview-modal__body {
  flex: 0 1 auto;
  max-height: 65dvh;
}

@supports not (height: 100dvh) {
  .excel-preview-modal-backdrop {
    height: 100vh;
  }
  .excel-preview-modal {
    max-height: calc(100vh - 1rem);
  }
  .excel-preview-modal--all {
    height: 94vh;
  }
  .excel-preview-modal--errors .excel-preview-modal__body {
    max-height: 65vh;
  }
}`],
})
export class PageIpManagementImportComponent implements OnInit, OnDestroy {
    public tenants: TenantOption[] = [];
    public duplicatePolicies: string[] = ['SKIP', 'UPDATE'];
    public maxFileBytes: number = 20 * 1024 * 1024;
    public maxCorrectionFileBytes: number = 5 * 1024 * 1024;
    public selectedTenantId: string = '';
    public duplicatePolicy: string = 'SKIP';
    public selectedFile: File | null = null;
    public job: any = null;
    public previewRows: any[] = [];
    public previewModalOpen: boolean = false;
    public previewModalMode: string = 'all';
    public previewModalRows: any[] = [];
    public previewModalLoading: boolean = false;
    public previewServerLimited: boolean = false;
    public previewPagination: any = { page: 1, limit: 50, total: 0, total_pages: 1 };
    public historyRows: any[] = [];
    public historyPage: number = 1;
    public readonly historyPageSize: number = 10;
    public loading: boolean = true;
    public uploading: boolean = false;
    public validating: boolean = false;
    public committing: boolean = false;
    public commitElapsedSeconds: number = 0;
    public historyRefreshing: boolean = false;
    public historyLastCheckedAt: string = '';
    public correctionUploading: boolean = false;
    public correctionUploadProgress: number = 0;
    public correctionFile: File | null = null;
    public uploadProgress: number = 0;
    public errorCode: string = '';
    public errorMessage: string = '';
    public errorTraceId: string = '';
    public successMessage: string = '';
    private previewScrollLocked: boolean = false;
    private previewScrollStage: HTMLElement | null = null;
    private previewPreviousStageOverflow: string = '';
    private previewPreviousBodyOverflow: string = '';
    private commitProgressTimer: any = null;
    private commitStartedAt: number = 0;
    private commitProgressPollBusy: boolean = false;
    private historyMonitorTimer: any = null;
    private historyRefreshBusy: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.loadInitial();
    }

    public ngOnDestroy() {
        this.stopCommitProgress();
        this.stopHistoryMonitor();
        this.unlockPreviewScroll();
    }

    private lockPreviewScroll() {
        if (this.previewScrollLocked) return;
        this.previewScrollStage = document.querySelector('.wb-route-stage') as HTMLElement | null;
        this.previewPreviousBodyOverflow = document.body.style.overflow;
        this.previewPreviousStageOverflow = this.previewScrollStage?.style.overflow || '';
        document.body.style.overflow = 'hidden';
        if (this.previewScrollStage) this.previewScrollStage.style.overflow = 'hidden';
        this.previewScrollLocked = true;
    }

    private unlockPreviewScroll() {
        if (!this.previewScrollLocked) return;
        document.body.style.overflow = this.previewPreviousBodyOverflow;
        if (this.previewScrollStage) {
            this.previewScrollStage.style.overflow = this.previewPreviousStageOverflow;
        }
        this.previewScrollStage = null;
        this.previewScrollLocked = false;
    }

    private mountPreviewModalToViewport() {
        const backdrop = document.querySelector('.excel-preview-modal-backdrop') as HTMLElement | null;
        if (backdrop && backdrop.parentElement !== document.body) {
            document.body.appendChild(backdrop);
        }
    }

    private responseData(response: any) {
        const payload = response && response.responseJSON ? response.responseJSON : response;
        const status = Number(payload?.code ?? response?.status ?? 500);
        const data = payload?.data;
        const errorData = data?.error || data || {};
        if (!payload || status >= 400) {
            const error: any = new Error(
                payload?.message
                || (typeof data === 'string' ? data : errorData?.message)
                || response?.statusText
                || '요청을 처리하지 못했습니다.'
            );
            error.code = payload?.error_code
                || errorData?.error_code
                || errorData?.code
                || 'REQUEST_FAILED';
            error.status = status;
            error.details = payload?.details || errorData?.details || [];
            error.traceId = payload?.trace_id || errorData?.trace_id || '';
            throw error;
        }
        return data;
    }

    private captureError(error: any) {
        this.errorCode = String(error?.code || 'REQUEST_FAILED');
        this.errorMessage = String(error?.message || '요청을 처리하지 못했습니다.');
        this.errorTraceId = String(error?.traceId || '');
        this.successMessage = '';
    }

    private clearMessage() {
        this.errorCode = '';
        this.errorMessage = '';
        this.errorTraceId = '';
        this.successMessage = '';
    }

    public async loadInitial() {
        this.loading = true;
        this.clearMessage();
        await this.service.render();
        try {
            const options = await wiz.call('options');
            const optionData: any = this.responseData(options);
            this.tenants = optionData?.tenants || [];
            this.duplicatePolicies = optionData?.duplicate_policies || ['SKIP', 'UPDATE'];
            this.maxFileBytes = Number(optionData?.limits?.max_file_bytes || 20 * 1024 * 1024);
            this.maxCorrectionFileBytes = Number(optionData?.limits?.max_correction_file_bytes || 5 * 1024 * 1024);
            if (!this.selectedTenantId && this.tenants.length) {
                this.selectedTenantId = this.tenants[0].id;
            }
            if (this.selectedTenantId) {
                const history = await wiz.call('history', { tenant_id: this.selectedTenantId });
                this.historyRows = this.responseData(history) || [];
                this.historyLastCheckedAt = new Date().toISOString();
            } else {
                this.historyRows = [];
            }
            this.syncHistoryMonitor();
        } catch (error) {
            this.captureError(error);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public selectedTenant() {
        return this.tenants.find((item) => item.id === this.selectedTenantId) || null;
    }

    public async onFileChange(event: any) {
        this.clearMessage();
        const files = event?.target?.files;
        this.selectedFile = files && files.length ? files[0] : null;
        if (this.selectedFile) {
            const lower = this.selectedFile.name.toLowerCase();
            if (!lower.endsWith('.xls') && !lower.endsWith('.xlsx')) {
                this.selectedFile = null;
                this.errorCode = 'UNSUPPORTED_FILE_TYPE';
                this.errorMessage = 'XLS 또는 XLSX 파일만 선택할 수 있습니다.';
            } else if (this.selectedFile.size > this.maxFileBytes) {
                this.selectedFile = null;
                this.errorCode = 'FILE_TOO_LARGE';
                this.errorMessage = '파일 크기는 20MB를 초과할 수 없습니다.';
            }
        }
        await this.service.render();
    }

    public async uploadFile() {
        if (!this.selectedTenantId || !this.selectedFile) {
            this.errorCode = 'UPLOAD_INPUT_REQUIRED';
            this.errorMessage = '대상 사무소와 Excel 파일을 선택해주세요.';
            await this.service.render();
            return;
        }
        this.uploading = true;
        this.uploadProgress = 0;
        this.clearMessage();
        await this.service.render();
        try {
            const form = new FormData();
            form.append('tenant_id', this.selectedTenantId);
            form.append('duplicate_policy', this.duplicatePolicy);
            form.append('file', this.selectedFile);
            const response: any = await this.service.file.upload(
                wiz.url('upload'),
                form,
                async (percent: number) => {
                    this.uploadProgress = percent;
                    await this.service.render();
                }
            );
            this.job = this.responseData(response);
            this.previewRows = [];
            this.correctionFile = null;
            this.successMessage = '파일을 안전하게 저장하고 헤더를 인식했습니다.';
            await this.refreshHistory();
        } catch (error) {
            this.captureError(error);
        } finally {
            this.uploading = false;
            await this.service.render();
        }
    }

    public downloadCorrectionTemplate() {
        if (!this.job || Number(this.job?.counts?.error || 0) < 1) return;
        this.clearMessage();
        const query = new URLSearchParams({
            tenant_id: String(this.job.tenant_id || ''),
            job_id: String(this.job.id || '')
        });
        const anchor = document.createElement('a');
        anchor.href = wiz.url('correction_template') + '?' + query.toString();
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
    }

    public async onCorrectionFileChange(event: any) {
        this.clearMessage();
        const files = event?.target?.files;
        this.correctionFile = files && files.length ? files[0] : null;
        if (this.correctionFile) {
            if (!this.correctionFile.name.toLowerCase().endsWith('.xlsx')) {
                this.correctionFile = null;
                this.errorCode = 'INVALID_CORRECTION_FILE_TYPE';
                this.errorMessage = '관리자 시스템에서 내려받은 XLSX 보정 파일만 선택해주세요.';
            } else if (this.correctionFile.size > this.maxCorrectionFileBytes) {
                this.correctionFile = null;
                this.errorCode = 'CORRECTION_FILE_TOO_LARGE';
                this.errorMessage = '오류 보정 파일은 5MB를 초과할 수 없습니다.';
            }
        }
        await this.service.render();
    }

    public async applyCorrections() {
        if (!this.job || !this.correctionFile || this.correctionUploading) return;
        this.correctionUploading = true;
        this.correctionUploadProgress = 0;
        this.clearMessage();
        await this.service.render();
        try {
            const form = new FormData();
            form.append('tenant_id', this.job.tenant_id);
            form.append('job_id', this.job.id);
            form.append('version', String(this.job.version));
            form.append('file', this.correctionFile);
            const response: any = await this.service.file.upload(
                wiz.url('apply_corrections'),
                form,
                async (percent: number) => {
                    this.correctionUploadProgress = percent;
                    await this.service.render();
                }
            );
            const data: any = this.responseData(response);
            if (!data?.job) throw new Error('보정 후 Import 작업 정보를 받지 못했습니다.');
            this.job = data.job;
            this.previewRows = Array.isArray(data.rows) ? data.rows : [];
            this.correctionFile = null;
            const applied = Number(data?.correction?.applied_rows || data?.applied_rows || 0);
            const remaining = Number(this.job?.counts?.error || 0);
            this.successMessage = remaining > 0
                ? `보정 ${applied}행을 반영하고 재검증했습니다. 남은 오류 ${remaining}건을 확인해주세요.`
                : `보정 ${applied}행을 반영하고 재검증했습니다. 이제 최종 반영할 수 있습니다.`;
            await this.refreshHistory();
        } catch (error) {
            if (error?.code === 'CORE_API_INVALID_ENDPOINT') {
                error.message = 'Core API의 오류 보정 병합 기능이 아직 배포되지 않았습니다. Core API 배포 후 다시 시도해주세요.';
            }
            this.captureError(error);
        } finally {
            this.correctionUploading = false;
            await this.service.render();
        }
    }

    public async runValidation() {
        if (!this.job) return;
        this.validating = true;
        this.clearMessage();
        await this.service.render();
        try {
            const response = await wiz.call('validate', {
                tenant_id: this.job.tenant_id,
                job_id: this.job.id,
                duplicate_policy: this.duplicatePolicy
            });
            const data: any = this.responseData(response);
            this.job = data.job;
            this.previewRows = data.rows || [];
            this.correctionFile = null;
            this.successMessage = this.job.counts.error
                ? '검증을 마쳤습니다. 오류 행을 확인해주세요.'
                : '검증을 마쳤습니다. 최종 반영 전 결과를 확인해주세요.';
            await this.refreshHistory();
        } catch (error) {
            this.captureError(error);
        } finally {
            this.validating = false;
            await this.service.render();
        }
    }

    public async openJob(item: any) {
        this.clearMessage();
        try {
            const response = await wiz.call('preview', {
                tenant_id: item.tenant_id || this.selectedTenantId,
                job_id: item.id
            });
            const data: any = this.responseData(response);
            this.job = data.job;
            this.previewRows = data.rows || [];
            this.correctionFile = null;
            this.selectedTenantId = this.job.tenant_id;
            this.duplicatePolicy = this.job.duplicate_policy;
        } catch (error) {
            this.captureError(error);
        }
        await this.service.render();
    }

    public async openPreviewModal(mode: string = 'all') {
        if (!this.job) return;
        this.previewModalOpen = true;
        this.previewModalMode = mode === 'errors' ? 'errors' : 'all';
        this.previewPagination = {
            page: 1,
            limit: Number(this.previewPagination?.limit || 50),
            total: 0,
            total_pages: 1
        };
        this.lockPreviewScroll();
        await this.service.render();
        this.mountPreviewModalToViewport();
        await this.loadPreviewPage(1);
    }

    public async closePreviewModal() {
        this.previewModalOpen = false;
        this.previewModalLoading = false;
        this.previewModalRows = [];
        this.unlockPreviewScroll();
        await this.service.render();
    }

    public async changePreviewMode(mode: string) {
        if (this.previewModalLoading) return;
        this.previewModalMode = mode === 'errors' ? 'errors' : 'all';
        await this.loadPreviewPage(1);
    }

    public async changePreviewLimit() {
        if (this.previewModalLoading) return;
        await this.loadPreviewPage(1);
    }

    public async loadPreviewPage(page: number) {
        if (!this.job || this.previewModalLoading) return;
        const totalPages = Math.max(Number(this.previewPagination?.total_pages || 1), 1);
        const targetPage = Math.min(Math.max(Number(page || 1), 1), totalPages);
        const limit = Math.min(Math.max(Number(this.previewPagination?.limit || 50), 20), 100);
        this.previewModalLoading = true;
        this.clearMessage();
        await this.service.render();
        try {
            const response = await wiz.call('preview', {
                tenant_id: this.job.tenant_id,
                job_id: this.job.id,
                page: targetPage,
                limit,
                issues_only: this.previewModalMode === 'errors' ? 'true' : 'false'
            });
            const data: any = this.responseData(response);
            const rows = Array.isArray(data?.rows) ? data.rows : [];
            const pagination = data?.pagination;
            this.previewServerLimited = !pagination;
            this.previewModalRows = this.previewModalMode === 'errors' && !pagination
                ? rows.filter((row: any) => this.rowHasError(row))
                : rows;
            if (pagination) {
                this.previewPagination = {
                    page: Number(pagination.page || targetPage),
                    limit: Number(pagination.limit || limit),
                    total: Number(pagination.total || 0),
                    total_pages: Math.max(Number(pagination.total_pages || 1), 1)
                };
            } else {
                this.previewPagination = {
                    page: 1,
                    limit,
                    total: this.previewModalMode === 'errors'
                        ? Number(this.job?.counts?.error || this.previewModalRows.length)
                        : Number(this.job?.total_rows || rows.length),
                    total_pages: 1
                };
            }
        } catch (error) {
            this.captureError(error);
        } finally {
            this.previewModalLoading = false;
            await this.service.render();
        }
    }

    public rowHasError(row: any) {
        if (row?.action === 'ERROR') return true;
        const issues = Array.isArray(row?.issues)
            ? row.issues
            : (row?.issues && typeof row.issues === 'object' ? [row.issues] : []);
        return issues.some((issue: any) => issue?.severity === 'ERROR');
    }

    public correctionHistory() {
        const rows = this.job?.correction_history || this.job?.corrections || [];
        return Array.isArray(rows) ? rows : [];
    }

    public correctionCount(item: any) {
        const count = Number(item?.correction_count || item?.corrections_count || 0);
        return Number.isFinite(count) ? count : 0;
    }

    public get historyPageCount(): number {
        return Math.max(1, Math.ceil(this.historyRows.length / this.historyPageSize));
    }

    public get historyPageNumbers(): number[] {
        return Array.from({ length: this.historyPageCount }, (_, index) => index + 1);
    }

    public get paginatedHistoryRows(): any[] {
        const start = (this.historyPage - 1) * this.historyPageSize;
        return this.historyRows.slice(start, start + this.historyPageSize);
    }

    public async goToHistoryPage(page: number) {
        this.historyPage = Math.min(Math.max(page, 1), this.historyPageCount);
        await this.service.render();
    }

    public runningHistoryJob(): any {
        return this.historyRows.find((item: any) =>
            ['VALIDATING', 'COMMITTING'].includes(String(item?.status || ''))
        ) || null;
    }

    public isHistoryRunning(item: any): boolean {
        return ['VALIDATING', 'COMMITTING'].includes(String(item?.status || ''));
    }

    public isHistoryLongRunning(item: any): boolean {
        return this.isHistoryRunning(item) && this.historyElapsedSeconds(item) >= 120;
    }

    private historyElapsedSeconds(item: any): number {
        const raw = item?.updated_at || item?.created_at;
        if (!raw) return 0;
        const started = new Date(raw).getTime();
        if (Number.isNaN(started)) return 0;
        return Math.max(0, Math.floor((Date.now() - started) / 1000));
    }

    public historyElapsedLabel(item: any): string {
        const seconds = this.historyElapsedSeconds(item);
        if (seconds < 60) return `${seconds}초`;
        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) return `${minutes}분 ${seconds % 60}초`;
        return `${Math.floor(minutes / 60)}시간 ${minutes % 60}분`;
    }

    public historyStatusDescription(item: any): string {
        const status = String(item?.status || '');
        if (status === 'COMMITTING') return 'Core가 데이터를 저장 중입니다. 완료 전에는 사무소 화면에 표시되지 않습니다.';
        if (status === 'VALIDATING') return '업로드한 행의 필수값과 중복 여부를 검사하고 있습니다.';
        if (status === 'COMPLETED') return '최종 반영이 완료되어 해당 사무소에서 확인할 수 있습니다.';
        if (status === 'FAILED') {
            const message = String(item?.failure_message || '').trim();
            const code = String(item?.failure_code || '').trim();
            return (message || '작업이 실패하여 데이터가 반영되지 않았습니다.') + (code ? ` (${code})` : '');
        }
        if (status === 'READY') return '검증이 끝났으며 관리자의 최종 반영을 기다리고 있습니다.';
        if (status === 'VALIDATED_WITH_ERRORS') return '오류를 보정하고 다시 검증해야 최종 반영할 수 있습니다.';
        if (status === 'MAPPING_REQUIRED') return '필수 컬럼 매핑을 확인해야 합니다.';
        if (status === 'MAPPED') return '컬럼 인식이 끝났으며 전체 검증을 기다리고 있습니다.';
        return '작업 상세에서 현재 상태를 확인해주세요.';
    }

    public historyRowClass(item: any): string {
        const status = String(item?.status || '');
        if (this.isHistoryRunning(item)) return 'bg-blue-50/60 hover:bg-blue-50';
        if (status === 'FAILED') return 'bg-rose-50/50 hover:bg-rose-50';
        if (status === 'COMPLETED') return 'bg-emerald-50/30 hover:bg-emerald-50';
        return 'hover:bg-slate-50';
    }

    private syncHistoryMonitor() {
        if (this.runningHistoryJob()) {
            if (!this.historyMonitorTimer) {
                this.historyMonitorTimer = setInterval(() => {
                    this.refreshHistoryStatus();
                }, 3000);
            }
            return;
        }
        this.stopHistoryMonitor();
    }

    private stopHistoryMonitor() {
        if (this.historyMonitorTimer) clearInterval(this.historyMonitorTimer);
        this.historyMonitorTimer = null;
        this.historyRefreshBusy = false;
    }

    public async refreshHistoryStatus() {
        if (this.historyRefreshBusy || !this.selectedTenantId || this.committing) return;
        this.historyRefreshBusy = true;
        this.historyRefreshing = true;
        try {
            const response = await wiz.call('history', { tenant_id: this.selectedTenantId });
            const rows = this.responseData(response) || [];
            if (!Array.isArray(rows)) return;
            this.historyRows = rows;
            this.historyLastCheckedAt = new Date().toISOString();
            const current = rows.find((item: any) =>
                String(item?.id || item?.job_id || '') === String(this.job?.id || '')
            );
            if (current) this.job = { ...this.job, ...current };
            this.syncHistoryMonitor();
        } catch (_error) {
            // Keep the last known status visible when a background refresh fails.
        } finally {
            this.historyRefreshBusy = false;
            this.historyRefreshing = false;
            await this.service.render();
        }
    }

    private startCommitProgress() {
        this.stopCommitProgress();
        this.commitStartedAt = Date.now();
        this.commitElapsedSeconds = 0;
        this.commitProgressTimer = setInterval(async () => {
            if (!this.committing) return;
            this.commitElapsedSeconds = Math.max(
                0,
                Math.floor((Date.now() - this.commitStartedAt) / 1000)
            );
            if (this.commitElapsedSeconds > 0 && this.commitElapsedSeconds % 3 === 0) {
                await this.pollCommitProgress();
            }
            await this.service.render();
        }, 1000);
    }

    private stopCommitProgress() {
        if (this.commitProgressTimer) clearInterval(this.commitProgressTimer);
        this.commitProgressTimer = null;
        this.commitStartedAt = 0;
        this.commitProgressPollBusy = false;
    }

    private async pollCommitProgress() {
        if (this.commitProgressPollBusy || !this.selectedTenantId || !this.job?.id) return;
        this.commitProgressPollBusy = true;
        try {
            const response = await wiz.call('history', { tenant_id: this.selectedTenantId });
            const rows = this.responseData(response) || [];
            if (!Array.isArray(rows)) return;
            this.historyRows = rows;
            const current = rows.find((item: any) =>
                String(item?.id || item?.job_id || '') === String(this.job?.id || '')
            );
            if (current) this.job = { ...this.job, ...current };
        } catch (_error) {
            // The commit request remains authoritative. A transient status poll
            // failure must not replace its eventual success or error response.
        } finally {
            this.commitProgressPollBusy = false;
        }
    }

    public commitProgressValue(): number | null {
        const progress = this.job?.commit_progress || this.job?.progress || {};
        const rawPercent = progress?.percent ?? this.job?.progress_percent;
        const percent = Number(rawPercent);
        if (rawPercent !== null && rawPercent !== undefined && Number.isFinite(percent)) {
            return Math.min(100, Math.max(0, Math.round(percent)));
        }
        const processed = this.commitProcessedRows();
        const total = Number(progress?.total_rows ?? this.job?.total_rows ?? 0);
        if (processed !== null && Number.isFinite(total) && total > 0) {
            return Math.min(100, Math.max(0, Math.round(processed / total * 100)));
        }
        return null;
    }

    public commitProcessedRows(): number | null {
        const progress = this.job?.commit_progress || this.job?.progress || {};
        const raw = progress?.processed_rows
            ?? progress?.processed
            ?? this.job?.processed_rows;
        if (raw !== null && raw !== undefined && raw !== '') {
            const value = Number(raw);
            return Number.isFinite(value) && value >= 0 ? value : null;
        }
        const committed = Number(this.job?.committed_count);
        if (Number.isFinite(committed) && (committed > 0 || this.job?.status === 'COMPLETED')) {
            return committed;
        }
        return null;
    }

    public commitElapsedLabel(): string {
        const seconds = Math.max(0, this.commitElapsedSeconds);
        if (seconds < 60) return `${seconds}초`;
        const minutes = Math.floor(seconds / 60);
        const remainder = seconds % 60;
        return remainder ? `${minutes}분 ${remainder}초` : `${minutes}분`;
    }

    public async commitJob() {
        if (!this.job || !this.canCommit()) return;
        const tenant = this.selectedTenant();
        const confirmed = await this.service.modal.show({
            title: 'Excel Import 최종 반영',
            message: `${tenant?.name || this.job.tenant_name} 범위에 고객·사건·권리 데이터를 반영합니다. 이 작업은 되돌릴 수 없습니다.`,
            action: '최종 반영',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.committing = true;
        this.startCommitProgress();
        this.clearMessage();
        await this.service.render();
        try {
            const response = await wiz.call('commit', {
                job_id: this.job.id,
                version: this.job.version,
                confirm_tenant_id: this.job.tenant_id
            });
            const data: any = this.responseData(response);
            this.job = data.job;
            this.successMessage = `반영 완료: 생성 ${data.result.created}건, 업데이트 ${data.result.updated}건, 건너뜀 ${data.result.skipped}건`;
            await this.refreshHistory();
        } catch (error) {
            this.captureError(error);
        } finally {
            this.committing = false;
            this.stopCommitProgress();
            this.syncHistoryMonitor();
            await this.service.render();
        }
    }

    private async refreshHistory() {
        if (!this.selectedTenantId) {
            this.historyRows = [];
            return;
        }
        const response = await wiz.call('history', { tenant_id: this.selectedTenantId });
        this.historyRows = this.responseData(response) || [];
        this.historyLastCheckedAt = new Date().toISOString();
        this.syncHistoryMonitor();
    }

    public async onTenantChange() {
        this.stopHistoryMonitor();
        this.job = null;
        this.previewRows = [];
        this.correctionFile = null;
        this.clearMessage();
        try {
            await this.refreshHistory();
        } catch (error) {
            this.captureError(error);
        }
        await this.service.render();
    }

    public mappingRows() {
        if (!this.job?.mapping) return [];
        const mapping = this.job.mapping;
        const recognizedHeaders: any = this.job.recognized_headers || [];
        const definitions: any[] = [
            { key: 'clients', fields: ['clients', 'client'], target: '고객 후보(의뢰인)' },
            { key: 'applicants', fields: ['applicants', 'applicant'], target: '사건 party(출원인)' },
            { key: 'right_holders', fields: ['right_holders', 'right_holder'], target: '사건 party(등록권리자)' },
            { key: 'title', fields: ['title'], target: '사건·권리명' },
            { key: 'right_type', fields: ['right_type'], target: '권리유형' },
            { key: 'application_number', fields: ['application_number'], target: '출원번호' },
            { key: 'application_date', fields: ['application_date'], target: '출원일' },
            { key: 'registration_number', fields: ['registration_number'], target: '등록번호' },
            { key: 'registration_date', fields: ['registration_date'], target: '등록일' },
            { key: 'legacy_status', fields: ['legacy_status', 'status'], target: '원문·표준 상태' },
            { key: 'case_assignee', fields: ['case_assignee', 'assignee'], target: '사건담당자' },
            { key: 'patent_attorney', fields: ['patent_attorney', 'attorney'], target: '담당변리사' },
            { key: 'deadlines', fields: ['deadlines', 'deadline'], target: '마감일' }
        ];

        return definitions.map((definition) => {
            const mappingKey = definition.fields.find((field: string) =>
                Object.prototype.hasOwnProperty.call(mapping, field)
            );
            const value = mappingKey ? mapping[mappingKey] : null;
            const values = Array.isArray(value) ? value : [value];
            const sources = values.map((item: any) => {
                if (typeof item === 'string' && item.trim()) return item.trim();
                if (item && typeof item === 'object' && typeof item.header === 'string') {
                    return item.header.trim();
                }
                if (typeof item === 'number') {
                    if (Array.isArray(recognizedHeaders)) {
                        const indexedHeader = recognizedHeaders[item];
                        if (typeof indexedHeader === 'string' && indexedHeader.trim()) {
                            return indexedHeader.trim();
                        }
                        const matched = recognizedHeaders.find((header: any) =>
                            definition.fields.indexOf(String(header?.field || '')) >= 0
                            && (header?.index === item || header?.column === item)
                        );
                        if (matched && typeof matched.header === 'string') {
                            return matched.header.trim();
                        }
                    } else if (recognizedHeaders && typeof recognizedHeaders === 'object') {
                        for (const field of definition.fields) {
                            const recognized = recognizedHeaders[field];
                            if (typeof recognized === 'string' && recognized.trim()) {
                                return recognized.trim();
                            }
                            if (recognized && typeof recognized.header === 'string') {
                                return recognized.header.trim();
                            }
                        }
                    }
                    return `열 ${item}`;
                }
                return '';
            }).filter((item: string) => !!item);
            return {
                key: definition.key,
                target: definition.target,
                sources,
                source: sources.join(', ') || '인식 안 됨',
                recognized: sources.length > 0
            };
        });
    }

    public missingMappingLabels() {
        const labels: any = {
            title: '사건·권리명',
            right_type: '권리유형',
            application_number: '출원번호',
            clients_or_applicants: '의뢰인 또는 출원인'
        };
        return (this.job?.missing_mapping || []).map((key: string) => labels[key] || key);
    }

    public canValidate() {
        return this.job
            && ['MAPPED', 'READY', 'VALIDATED_WITH_ERRORS', 'FAILED'].indexOf(this.job.status) >= 0
            && (!this.job.missing_mapping || this.job.missing_mapping.length === 0);
    }

    public canCommit() {
        return this.job
            && this.job.status === 'READY'
            && this.job.counts.error === 0
            && this.job.commit_allowed
            && !this.committing;
    }

    public commitActionLabel(): string {
        const status = String(this.job?.status || '');
        if (this.committing || status === 'COMMITTING') return '반영 처리 중';
        if (status === 'COMPLETED') return '반영 완료';
        if (status === 'FAILED') return '반영 실패';
        if (Number(this.job?.counts?.error || 0) > 0) return '오류 보정 필요';
        if (!this.job?.commit_allowed) return '반영 정책 확인 필요';
        if (status !== 'READY') return '검증 완료 후 반영';
        return 'Excel Import 최종 반영';
    }

    public stepState(step: number) {
        if (!this.job) return step === 1 ? 'active' : 'idle';
        if (step === 1) return 'done';
        if (step === 2) return ['MAPPED', 'MAPPING_REQUIRED'].indexOf(this.job.status) >= 0 ? 'active' : 'done';
        if (step === 3) return ['READY', 'VALIDATED_WITH_ERRORS'].indexOf(this.job.status) >= 0 ? 'active' : (this.job.status === 'COMPLETED' ? 'done' : 'idle');
        return this.job.status === 'COMPLETED' ? 'done' : 'idle';
    }

    public statusLabel(status: string) {
        const labels: any = {
            UPLOADED: '업로드됨',
            MAPPING_REQUIRED: '매핑 확인 필요',
            MAPPED: '컬럼 인식 완료',
            VALIDATING: '검증 중',
            READY: '반영 준비',
            VALIDATED_WITH_ERRORS: '오류 확인 필요',
            COMMITTING: '반영 중',
            COMPLETED: '완료',
            FAILED: '실패',
            CANCELLED: '취소'
        };
        return labels[status] || status;
    }

    public statusClass(status: string) {
        if (status === 'COMPLETED' || status === 'READY') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === 'FAILED' || status === 'VALIDATED_WITH_ERRORS') return 'border-rose-200 bg-rose-50 text-rose-700';
        if (status === 'MAPPED' || status === 'VALIDATING' || status === 'COMMITTING') return 'border-blue-200 bg-blue-50 text-blue-700';
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public actionClass(action: string) {
        if (action === 'CREATE') return 'bg-emerald-50 text-emerald-700';
        if (action === 'UPDATE') return 'bg-blue-50 text-blue-700';
        if (action === 'ERROR') return 'bg-rose-50 text-rose-700';
        return 'bg-slate-100 text-slate-600';
    }

    public formatBytes(size: number) {
        if (!size) return '0 B';
        if (size < 1024 * 1024) return `${Math.ceil(size / 1024)} KB`;
        return `${(size / 1024 / 1024).toFixed(1)} MB`;
    }

    public formatDate(value: string) {
        if (!value) return '-';
        return value.replace('T', ' ').replace('Z', '').slice(0, 16);
    }
}

export default PageIpManagementImportComponent;